export default __webpack_public_path__ + "static/media/get-loan.ba5123c4.svg";